// assets/flyout-fix.js
(function () {
  // --- Utils ---------------------------------------------------------------
  const normalize = (url) => {
    if (!url) return '';
    return url
      .replace(/^https?:\/\/[^/]+/, '')
      .replace(/^shopify:\/\/pages/, '/pages')
      .replace(/^shopify:\/\/collections/, '/collections')
      .replace(/^shopify:\/\//, '/')
      .replace(/\/+$/, '');
  };

  const q  = (sel, ctx = document) => ctx.querySelector(sel);
  const qa = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  const getDropdownFor = (href) => {
    const path = normalize(href);
    return q(`[data-header-dropdown-menu][data-link="${path}"]`);
  };

  // --- Desktop Hover-Flyouts ----------------------------------------------
  function showDropdownFor(href) {
    const drop = getDropdownFor(href);
    if (drop) drop.classList.remove('hidden', 'opacity-0', 'pointer-events-none');
  }
  function hideDropdownFor(href) {
    const drop = getDropdownFor(href);
    if (drop) drop.classList.add('hidden', 'opacity-0', 'pointer-events-none');
  }
  function bindHoverPersistence(drop) {
    let inside = false;
    drop.addEventListener('pointerenter', () => {
      inside = true;
      drop.classList.remove('hidden', 'opacity-0', 'pointer-events-none');
    });
    drop.addEventListener('pointerleave', () => {
      inside = false;
      drop.classList.add('hidden', 'opacity-0', 'pointer-events-none');
    });
    return () => inside;
  }
  function bindNavLink(link) {
    const href = link.getAttribute('href');
    const drop = getDropdownFor(href);
    const isOverPanel = drop ? bindHoverPersistence(drop) : () => false;
    link.addEventListener('pointerenter', () => showDropdownFor(href));
    link.addEventListener('pointerleave', () => {
      setTimeout(() => { if (!isOverPanel()) hideDropdownFor(href); }, 200);
    });
  }
  function init() { qa('[data-nav-link]').forEach(bindNavLink); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // --- Ignore legacy 'r.style' error --------------------------------------
  window.addEventListener('error', function (e) {
    if (typeof e.message === 'string' && e.message.includes('r.style')) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);

  // --- Mobile-Menü: mehrstufig --------------------------------------------
  const _menuStackMap = new WeakMap();
  const _submenuMap   = new WeakMap();
  const drawerSelector = '[data-mobile-menu], [data-drawer-id="mobile-menu"], [data-drawer-id="mobile-menu-custom"], [data-drawer-id="drawer-mobile-menu"]';

  // Öffnen von Untermenüs
  document.addEventListener('click', (e) => {
    const drawer = e.target.closest(drawerSelector);
    if (!drawer) return;

    const toggleBtn = e.target.closest('[data-mobile-submenu-toggle]');
    if (!toggleBtn) return;

    e.preventDefault();
    // Nur Submenu-Interaktion stoppen – nicht globale Buttons (z.B. Sprache)
    e.stopImmediatePropagation();

    const currentLevel = toggleBtn.closest('[data-menu-level]');
    if (!currentLevel) return;

    let submenu = _submenuMap.get(toggleBtn);
    if (!submenu) {
      const maybe = toggleBtn.nextElementSibling;
      if (!maybe || !maybe.matches('[data-menu-level]')) return;
      _submenuMap.set(toggleBtn, maybe);
      submenu = maybe;
    }

    const host = drawer.querySelector('[data-menu-container]');
    if (!host) return;

    if (submenu.parentElement !== host) {
      submenu.classList.add('absolute', 'inset-0', 'z-10');
      host.appendChild(submenu);
    }

    const stack = _menuStackMap.get(drawer) || [];
    if (stack.length === 0) {
      drawer.querySelectorAll('[data-mobile-extras]').forEach(el => el.classList.add('hidden'));
    }
    stack.push(currentLevel);
    _menuStackMap.set(drawer, stack);

    currentLevel.classList.add('translate-x-full');
    submenu.classList.remove('hidden', 'translate-x-full');
  });

  // Zurück
  document.addEventListener('click', (e) => {
    const drawer = e.target.closest(drawerSelector);
    if (!drawer) return;

    const backBtn = e.target.closest('[data-mobile-submenu-back]');
    if (!backBtn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const submenu = backBtn.closest('[data-menu-level]');
    const stack = _menuStackMap.get(drawer) || [];
    const parentLevel = stack.pop();
    _menuStackMap.set(drawer, stack);

    submenu.classList.add('translate-x-full');
    setTimeout(() => submenu.classList.add('hidden'), 300);

    if (parentLevel) parentLevel.classList.remove('translate-x-full');

    if (stack.length === 0) {
      drawer.querySelectorAll('[data-mobile-extras]').forEach(el => el.classList.remove('hidden'));
    }
  });

  // Keine Handler für data-language-popup-toggle hier – das macht das Theme.
})();
